import {
  COLUMN_FILTER_OPERATORS,
  COLUMN_FILTER_OPERATORS_BY_KIND,
} from '../constants/materialDashboardConstants';
import { getColumnFilterKind } from './getColumnFilterKind';

/**
 * Operadores válidos para filtrar una columna: texto admite igualdad y "contiene"; números y
 * fechas, igualdad y comparadores.
 * @param {string} column Clave de la columna.
 * @returns {Array<{value: string, label: string, symbol: string}>} Opciones del selector.
 */
export const getColumnFilterOperators = (column) => {
  const allowed = COLUMN_FILTER_OPERATORS_BY_KIND[getColumnFilterKind(column)];
  return COLUMN_FILTER_OPERATORS.filter((option) => allowed.includes(option.value));
};
